import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const AttributeButtonStyled = styled(Button)`
  text-transform: uppercase;
  font-weight: 700;
`;
